
import { Component, Prop, Mixins } from 'vue-property-decorator';
import hexToRgba from 'hex-to-rgba';
import SiteMap from '../molecules/SiteMap.vue';
import LanguageSwitch from '../molecules/LanguageSwitch.vue';
import UserLogout from '../molecules/UserLogout.vue';
import Links from '../molecules/Links.vue';
import Copyright from '../atoms/Copyright.vue';
import { FontMixin, Font } from '../../mixins/Font';

interface Link {
  label: string
  href?: string
}

interface Labels {
  userLogoutHeadline: string
  userLogooutButton: string
}

@Component({
  components: {
    SiteMap,
    LanguageSwitch,
    UserLogout,
    Links,
    Copyright,
  },
})
export default class Footer extends Mixins(FontMixin) {
  @Prop({ default: false }) isDark!: boolean;
  @Prop({ default: false }) isRounded!: boolean;
  @Prop({ default: false }) isLanguagePrimaryBorder!: boolean;
  @Prop() primaryColor!: string;
  @Prop() currentLocale!: string;
  @Prop() locales!: string[];
  @Prop() siteMap!: Link[];
  @Prop() links!: Link[];
  @Prop() userName!: string;
  @Prop() userImageUrl!: string;
  @Prop({ required: true }) labels!: Labels;
  @Prop({ default: 1 }) opacity!: number; // @deprecated
  @Prop({ default: Font.PT_MONO }) font!: Font;
  @Prop() backgroundColor!: string
  @Prop() textColor!: string

  get classNames() {
    return [
      { 'footer--rounded': this.isRounded },
    ];
  }

  get style() {
    return {
      background: this.backgroundColor || hexToRgba(this.isDark ? '#000' : '#fff', this.opacity),
      fontFamily: this.$getFontFamily(this.font),
      // fontSize: this.font === Font.POPPINS ? '16px' : '18px', // poppins needs smaller
    };
  }
}
